import { render, staticRenderFns } from "./GenericDataTable.vue?vue&type=template&id=4b91636b&scoped=true"
import script from "./GenericDataTable.vue?vue&type=script&lang=js"
export * from "./GenericDataTable.vue?vue&type=script&lang=js"
import style0 from "./GenericDataTable.vue?vue&type=style&index=0&id=4b91636b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b91636b",
  null
  
)

export default component.exports